import { load } from '@/util/router-utils.js'

import farm from './farm'
import admin from './admin'

export default [
  {
    name: 'companies',
    path: 'companies',
    component: load('app/client/companies/Index')
  },
  {
    name: 'helpdesk',
    path: 'helpdesk',
    component: load('app/client/helpdesk/Index')
  },
  {
    path: 'companies/:company_id',
    redirect: 'companies/:company_id/farms',
    component: load('app/client/companies/_id/Index'),
    children: [
      {
        path: 'stocks',
        component: load('app/client/stocks/Index')
      },
      {
        path: 'stocks/:stock_id',
        component: load('app/client/stocks/id/Index')
      },
      {
        path: 'farms',
        component: load('app/client/farms/Index'),
      },
      ...farm
    ]
  },
  ...admin
]
